import screenfull from 'screenfull';
import appParameters from './AppParameters';
import modeType from '../../constants/ModeConstants';
import platformDetection from './PlatformDetection';

const fullScreenManager = {
    isIOSFullScreen: false, //FULLSCREEN mode for IOS
    fullScreenInitialized: false,
    isOverControlBar: false,
    isMouseMoved: false,
    fullScreenTimerVar: undefined,
    refreshFunction: undefined,
    refreshExportPlayer: undefined,
    isInitialized: false,

    init() {
        // override for CH-661
        screenfull.request = function (elem) {
            let request = screenfull.raw.requestFullscreen;

            elem = elem || document.documentElement;
            elem[request]();
        };

        screenfull.on('change', this.changeFullScreen.bind(this));

        this.isInitialized = true;
    },
    isIOSMode() {
        if (platformDetection.isIOS() || platformDetection.isAndroid())
            return true;

        return false;

        var isMobile = window.innerWidth < 800;

        if (isMobile)
            return true;
        else
            return false;
    },
    isIOSFullScreenMode() {
        if (this.isIOSFullScreen)
            return true;

        if (window.location && window.location.ancestorOrigins && window.location.ancestorOrigins[0] && window.location.ancestorOrigins[0].indexOf('portal') != -1)
            return false;

        if (window.parent && window.parent.location && window.parent.location.href && window.parent.location.href.indexOf('isFullscreen=true') != -1)
            return true;
        else
            return false;
    },
    getCurrentPosition() {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return 0;

        return video.currentTime;
    },
    goFullScreenMode() {
        if (!this.isIOSMode() && appParameters.context != modeType.EXPORT_AUDIO_PLAYER)
            this.addFullScreenEvents();

        if (this.isIOSMode()) {
            if (this.isIOSFullScreenMode()) {
                // exit fullScreen mode
                this.isIOSFullScreen = false;
                this.isOverControlBar = false;
                this.isMouseMoved = false;
                this.clearFullScreenMouseMove();

                window.location.href = appParameters.playerHref;
            } else {
                // go to fullScreen mode
                if (window.parent && window.parent.location) {
                    this.isIOSFullScreen = true;
                    this.isMouseMoved = true;

                    if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER)
                        window.parent.location.href = appParameters.iframeSrc + '&isFullscreen=true' + '&playerCurrentTime=' + this.getCurrentPosition();
                    else
                        window.parent.location.href = appParameters.iframeSrc + '&isFullscreen=true';
                }
            }
        } else {
            if (!screenfull.enabled)
                return;

            if (!this.isInitialized)
                this.init();

            if (screenfull.isFullscreen)
                this.exitFullScreen();

            const app = document.getElementById('app');
            screenfull.toggle(app);
        }
    },
    isFullScreenMode() {
        if (appParameters.getMode() == modeType.PLAYER || appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            if (this.isIOSMode())
                return this.isIOSFullScreenMode();
            else
                return screenfull.isFullscreen;
        } else
            return false;
    },
    addFullScreenEvents() {
        if (this.fullScreenInitialized == true)
            return;

        if (!this.isIOSMode()) {
            const controlBar = document.getElementById('previewMenu');
            const canvas = document.getElementById('svgContainer');

            controlBar.addEventListener('mouseover', this.onControlBarMouseOver.bind(this));
            controlBar.addEventListener('mouseout', this.onControlBarMouseOut.bind(this));

            canvas.addEventListener('mousemove', this.onCanvasMouseMove.bind(this));
            this.fullScreenInitialized = true;
        }
    },
    changeFullScreen() {
        if (!this.isFullScreenMode())
            this.exitFullScreen();
    },
    addFullScreenEventsForIOS() {
        if (this.fullScreenInitialized == true)
            return;

        const canvas = document.getElementById('svgContainer');

        this.fullScreenInitialized = true;
        this.isIOSFullScreen = true;
        canvas.addEventListener('touchstart', this.onCanvasTouch.bind(this));

        this.onCanvasTouch();
    },
    onCanvasTouch() {
        if (this.isFullScreenMode() == false)
            return;

        this.clearFullScreenMouseMove();
        this.fullScreenTimerVar = setInterval(this.hideControlBar.bind(this), 6 * 1000);

        this.isMouseMoved = true;
        this.refreshControlBar();
    },
    onControlBarMouseOver() {
        if (this.isFullScreenMode() == false)
            return;

        this.isOverControlBar = true;
        this.isMouseMoved = false;
        this.refreshControlBar();
    },
    onControlBarMouseOut() {
        if (this.isFullScreenMode() == false)
            return;

        this.isOverControlBar = false;
        this.isMouseMoved = false;
        this.refreshControlBar();
    },
    onCanvasMouseMove() {
        if (this.isFullScreenMode() == false)
            return;

        if (this.isOverControlBar == true)
            return;

        this.clearFullScreenMouseMove();

        if (this.isMouseMoved == false) {
            this.isMouseMoved = true;
            this.refreshControlBar();
        } else
            this.isMouseMoved = true;

        this.hideCursor(false);

        this.fullScreenTimerVar = setInterval(this.hideControlBar.bind(this), 3 * 1000);
    },
    hideControlBar() {
        this.isMouseMoved = false;
        this.refreshControlBar();
        this.clearFullScreenMouseMove();
        this.hideCursor();
    },
    hideCursor(hide = true) {
        var container = document.getElementById('svgContainer');
        if (container) {
            if (hide)
                container.style.cursor = 'none';
            else
                container.style.cursor = 'default';
        }
    },
    clearFullScreenMouseMove() {
        if (this.fullScreenTimerVar)
            clearInterval(this.fullScreenTimerVar);
    },
    isControlBarVisible() {
        if (this.isOverControlBar == true || this.isMouseMoved == true)
            return true;
        else
            return false;
    },
    refreshControlBar() {
        if (this.refreshFunction)
            this.refreshFunction();
    },
    exitFullScreen() {
        this.hideCursor(false);

        if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            if (this.refreshExportPlayer)
                this.refreshExportPlayer();

            if (appParameters.context == modeType.EXPORT_AUDIO_PLAYER)
                return;
        }

        this.isOverControlBar = false;
        this.isMouseMoved = false;
        this.clearFullScreenMouseMove();
    }
};

export default fullScreenManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/FullScreenManager.js
 **/